import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () =>
      import('@/routes/dashboard-layout.routes').then(
        (m) => m.dashboardLayoutRoutes,
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('@/routes/main-layout.routes').then((m) => m.mainLayoutRoutes),
  },
  {
    path: '',
    loadChildren: () =>
      import('@/routes/empty-layout.routes').then((m) => m.emptyLayoutRoutes),
  },
];
